import { useDispatch, useSelector } from "react-redux"
import { updatePostAsync } from "../../features/post/postSlice";
import Tags from "../common/Tags"

export default function PostDetails({ post }) {
  const { id, title, description, image, tags, likes, isSaved, createdAt } = post || {}

  const { isUpading } = useSelector(state => state.post);

  const dispatch = useDispatch();

  const  savedClickHandler= () => {
    if(isUpading) return;
    const value = !isSaved;
    dispatch(updatePostAsync({id,fieldName:'isSaved',value}))
  }

  const likeClickHandler = () => {
    if(isUpading) return;
    const value = likes+1;
    dispatch(updatePostAsync({id,fieldName:'likes',value}))
  }

  return (
    <main className="post">
      <img src={image} alt={title} className="w-full rounded-md" id="lws-megaThumb" />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
          <Tags tags={tags} />
        </div>
        <div className="btn-group">
          {/* <!-- handle like on button click --> */}
          <button disabled={isUpading} className="like-btn" id="lws-singleLinks" onClick={likeClickHandler}>
            <i className="fa-regular fa-thumbs-up"></i> {likes}
          </button>
          {/* <!-- handle save on button click --> */}
          {/* <!-- use ".active" class and "Saved" text  if a post is saved, other wise "Save" --> */}
          <button disabled={isUpading} className={`save-btn ${isSaved && 'active'}`} id="lws-singleSavedBtn" onClick={savedClickHandler}>
            <i className="fa-regular fa-bookmark"></i> Saved
          </button>
        </div>
        <div className="mt-6">
          <p>
            {description}
          </p>
        </div>
      </div>
    </main>
  )
}